import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { StyledTableContainer } from "components/StyledComponents/styledComponents";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import {
  StyledAgGridContainer,
  StyledSnackbar,
  StyledAlert,
} from "components/StyledComponents/styledComponents";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { Paper, Dialog, DialogContent, CircularProgress } from "@mui/material";
import InsuranceDashboard from "./insuranceReportSheet";
import { Box, TextField, Button, Typography } from "@mui/material";
import { StyledButton } from "components/StyledComponents/styledComponents";

const InsuranceReportsheet = () => {
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const [selectedDate, setSelectedDate] = useState(getTodayDate());
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [currentRenewals, setCurrentRenewals] = useState(null);
  const [unPaidRenewals, setUnPaidRenewals] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [firstScheduleRevenu, setFirstScheduleRevenue] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [alertType, setAlertType] = useState("success");
  const jwt_token = Cookie.get("jwt_token");
  const getStartOfMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 2).toISOString().split("T")[0];
  };
  const getEndOfMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split("T")[0];
  };
  const [revenueStartDate, setRevenueStartDate] = useState(getStartOfMonth());
  const [revenueEndDate, setRevenueEndDate] = useState(getEndOfMonth());
  const [footerData, setFooterData] = useState([]);
  const tabs = [
    { label: "All Policies" },
    { label: "Due This Month" },
    { label: "Pending Renewals" },
    { label: "Cleared Renewals" },
    { label: "Revenue on Insurance" },
  ];
  const [rowData, setRowData] = useState([]);
  const [monthlyPremiumTotal, setMonthlyPremiumTotal] = useState(0);
  const [monthlyPayoutTotal, setMonthlyPayoutTotal] = useState(0);
  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    if (!Array.isArray(currentRenewals) || !Array.isArray(unPaidRenewals)) return;

    const separatorRow = {
      isLabelRow: true,
      label: " Overdue ",
    };

    if (currentRenewals.length > 0 || unPaidRenewals.length > 0) {
      const combined = [...currentRenewals];
      if (unPaidRenewals.length > 0) {
        combined.push(separatorRow, ...unPaidRenewals);
      }
      setCombinedData(combined);
    }
  }, [currentRenewals, unPaidRenewals]);
  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const fetchAllInsuranceData = async () => {
    const url = `${URLs.insuranceGetAllEntries}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setRowData(data);
      } else {
        setAlert("Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchCurrentRenewals = async (paidStatus) => {
    if (revenueStartDate && revenueEndDate) {
      const url = `${URLs.insuranceReportsUrl}?startDate=${revenueStartDate}&endDate=${revenueEndDate}&paidStatus=${paidStatus}`;
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        };
        const response = await fetch(url, options);
        if (response.ok) {
          const data = await response.json();
          setCurrentRenewals(data);
        } else {
          setAlert("Failed to fetch data", "error");
        }
      } catch (error) {
        setAlert("An error occurred while fetching data", "error");
      } finally {
        setLoading(false);
      }
    } else {
      // Optional: Handle case when no date selected
      setAlert("Please select a date", "error");
    }
  };
  const fetchNonRenewals = async () => {
    const url = `${URLs.unPaidInsuranceUrl}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setUnPaidRenewals(data);
      } else {
        setAlert("Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchfirstScheduleRevenu = async () => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const startDate = revenueStartDate || startOfMonth.toISOString().split("T")[0];
    const endDate = revenueEndDate || endOfMonth.toISOString().split("T")[0];
    const url = `${URLs.insuranceFirstSchedule}?startDate=${startDate}&endDate=${endDate}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setFirstScheduleRevenue(data);
      } else {
        setAlert("Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchRevenu = async (payoutStatus, startDateInput, endDateInput) => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const startDate = startDateInput || startOfMonth.toISOString().split("T")[0];
    const endDate = endDateInput || endOfMonth.toISOString().split("T")[0];

    const url = `${URLs.insuranceRevenu}?startDate=${startDate}&endDate=${endDate}&payoutStatus=${payoutStatus}`;

    setLoading(true);

    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };

      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setRevenue(data);
      } else {
        setAlert("Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const handleTabData = async () => {
      switch (activeTab) {
        case 0:
          setUnPaidRenewals([]);
          await fetchAllInsuranceData();
          break;
        case 1:
          setCurrentRenewals([]);
          await Promise.all([fetchCurrentRenewals("A"), fetchNonRenewals()]);
          break;
        case 2:
          setCombinedData([]);
          await Promise.all([fetchCurrentRenewals("N"), fetchNonRenewals()]);
          break;
        case 3:
          setCurrentRenewals([]);
          setUnPaidRenewals([]);
          setCombinedData([]);
          await fetchCurrentRenewals("Y");
          break;
        case 4:
          await Promise.all([
            fetchCurrentRenewals("A"),
            fetchRevenu("Y"),
            fetchfirstScheduleRevenu(),
          ]);
          break;
        default:
          break;
      }
    };

    handleTabData();
  }, [activeTab, selectedDate]);

  const columns = [
    {
      headerName: "Policy Start Date",
      field: "nextRenewalDate",
      filter: true,
      valueFormatter: (params) => formatDate(params.value),
    },
    { headerName: "Customer Name", field: "customerName", filter: true, flex: 1.5 },
    { headerName: "Application Number", field: "applicationNumber", filter: true },
    { headerName: "Provider Name", field: "providerName", flex: 1.5, filter: true },
    { headerName: "Agent Name", field: "agentName", flex: 1, filter: true },
    {
      headerName: "Premium Amount",
      field: "premiumAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
  ];
  const formatAmount = (amount) => {
    if (amount == null) return "";
    return "₹" + amount.toLocaleString("en-IN", { minimumFractionDigits: 2 });
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.getDate()}-${date.toLocaleString("en-US", {
      month: "short",
    })}-${date.getFullYear()}`;
  };
  const getPaymentStatusText = (paidStatus, payoutStatus) => {
    if (paidStatus === "N" || paidStatus === null || paidStatus === undefined) {
      return "Unpaid";
    } else if (paidStatus === "Y" && payoutStatus === "Y") {
      return "Paid & Payout Received";
    } else if (paidStatus === "Y" && payoutStatus === "N") {
      return "Paid but Payout Pending";
    }
    return "Unknown";
  };
  const actionCode = (params) => {
    const paidStatus = params.data.paidStatus;
    const payoutStatus = params.data.payoutStatus;

    let color = "#333";
    let backgroundColor = "#F5F5F5";
    let borderColor = "#E0E0E0";

    if (paidStatus === "N" || paidStatus === null || paidStatus === undefined) {
      color = "#D32F2F";
      backgroundColor = "#FFEBEE";
      borderColor = "#FFCDD2";
    } else if (paidStatus === "Y" && payoutStatus === "Y") {
      color = "#8E24AA";
      backgroundColor = "#F3E5F5";
      borderColor = "#E1BEE7";
    } else if (paidStatus === "Y" && payoutStatus === "N") {
      color = "#F57C00";
      backgroundColor = "#FFF3E0";
      borderColor = "#FFE0B2";
    }

    return (
      <div
        style={{
          height: "30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6px 14px",
          borderRadius: "999px", // Fully rounded pill
          fontSize: "15px",
          fontWeight: 700,
          color: color,
          textAlign: "center",
          backgroundColor: backgroundColor,
          border: `1px solid ${borderColor}`,
          transition: "all 0.3s ease",
        }}
      >
        {getPaymentStatusText(paidStatus, payoutStatus)}
      </div>
    );
  };
  const columnDefs = [
    {
      headerName: "Policy Start Date",
      field: "policyStartDate",
      filter: true,
      maxWidth: 140,
      valueFormatter: ({ value }) => formatDate(value),
      cellRenderer: ({ data, value }) => {
        if (data?.isLabelRow) {
          const count = Array.isArray(unPaidRenewals) ? unPaidRenewals.length : 0;
          return (
            <div
              style={{
                fontWeight: "bold",
                textAlign: "center",
                width: "100%",
                color: "#ffffff",
                backgroundColor: "#1C2526", // Sleek black background
                paddingLeft: "10px",
                paddingRight: "10px",
                borderRadius: "10px", // Smooth border radius
                display: "flex", // Flexbox for centering
                justifyContent: "center", // Horizontal centering
                alignItems: "center", // Vertical centering
                height: "100%", // Ensure full cell height for vertical centering
              }}
            >
              {`${count} ${data.label}`}
            </div>
          );
        }
        return value;
      },
    },
    {
      headerName: "Renewal Date",
      field: "renewalDate",
      filter: true,
      maxWidth: 140,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      headerName: "Policy Number",
      field: "applicationNumber",
      filter: true,
      flex: 1,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      flex: 1.5,
    },

    {
      headerName: "Provider Name",
      field: "providerName",
      filter: true,
      flex: 1.5,
    },
    {
      headerName: "Agent Name",
      field: "agentName",
      filter: true,
      flex: 1,
    },
    {
      headerName: "Premium Amount",
      field: "premiumAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: { fontWeight: "bold", textAlign: "right" },
    },
    {
      headerName: "Paid Amount",
      field: "paidAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: { fontWeight: "bold", textAlign: "right" },
    },
    {
      headerName: "Payout Amount",
      field: "payoutAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: { fontWeight: "bold", textAlign: "right" },
    },
    {
      headerName: "Status",
      field: "paidStatus",
      filter: true,
      align: "center",
      valueGetter: (params) => {
        if (params.data?.isLabelRow) return ""; // Hide value for label row
        return getPaymentStatusText(params.data.paidStatus, params.data.payoutStatus);
      },
      cellRenderer: (params) => {
        if (params.data?.isLabelRow) return null; // Hide renderer for label row
        return actionCode(params); // Your existing custom renderer
      },
    },
  ];
  const columnAgDefs = [
    {
      headerName: "Policy Start Date",
      field: "policyStartDate",
      filter: true,
      maxWidth: 140,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      headerName: "Renewal Date",
      field: "renewalDate",
      filter: true,
      maxWidth: 140,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      headerName: "Policy Number",
      field: "applicationNumber",
      filter: true,
      flex: 1,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      flex: 1.5,
    },
    {
      headerName: "Provider Name",
      field: "providerName",
      filter: true,
      flex: 1.5,
    },
    {
      headerName: "Agent Name",
      field: "agentName",
      filter: true,
      flex: 1,
    },
    {
      headerName: "Premium Amount",
      field: "premiumAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: { fontWeight: "bold", textAlign: "right" },
    },
    {
      headerName: "Payout Amount",
      field: "payoutAmount",
      filter: true,
      valueFormatter: (params) => formatAmount(params.value),
      cellStyle: { fontWeight: "bold", textAlign: "right" },
    },
  ];
  const handleTabChange = () => {
    return (
      <>
        <StyledAgGridContainer
          component={Paper}
          className="ag-theme-alpine"
          sx={{
            flexGrow: 1,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          <AgGridReact
            rowData={combinedData}
            defaultColDef={{ floatingFilter: true }}
            columnDefs={columnDefs}
            pagination
            paginationPageSize={11}
            getRowStyle={(params) => {
              if (params.data?.isLabelRow) {
                return {
                  backgroundColor: "orange",
                  fontWeight: "bold",
                  textAlign: "center",
                };
              }
              return {};
            }}
            getRowHeight={(params) => (params.data?.isLabelRow ? 60 : undefined)}
          />
        </StyledAgGridContainer>
      </>
    );
  };
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  useEffect(() => {
    if (!Array.isArray(revenue)) return;

    const totalPayout = revenue.reduce((sum, row) => sum + (parseFloat(row.payoutAmount) || 0), 0);

    setFooterData([
      {
        customerName: "Total",
        payoutAmount: totalPayout,
      },
    ]);
  }, [revenue]);
  useEffect(() => {
    if (!Array.isArray(firstScheduleRevenu) || firstScheduleRevenu.length === 0) {
      setMonthlyPremiumTotal(0);
      setMonthlyPayoutTotal(0);
      return;
    }
    const { totalPremiumAmount, totalPayoutAmount } = firstScheduleRevenu[0] || {};
    setMonthlyPremiumTotal(totalPremiumAmount || 0);
    setMonthlyPayoutTotal(totalPayoutAmount || 0);
  }, [firstScheduleRevenu]);
  useEffect(() => {
    fetchRevenu("Y", revenueStartDate, revenueEndDate);
    fetchfirstScheduleRevenu();
    fetchCurrentRenewals("A");
  }, [revenueStartDate, revenueEndDate]);
  const [totalCommission, setTotalCommission] = useState(0);
  useEffect(() => {
    if (Array.isArray(currentRenewals) && activeTab == 4) {
      const total = currentRenewals.reduce((sum, item) => {
        if (item && typeof item.payoutAmount === "number") {
          return sum + item.payoutAmount;
        }
        return sum;
      }, 0);

      setTotalCommission(total);
    }
  }, [currentRenewals]);
  const handleRevenueTabChange = () => {
    return (
      <>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          pt={1}
          mb={2}
          sx={{ width: "100%" }}
          flexWrap="wrap"
        >
          <Box display="flex" gap={2}>
            <TextField
              label="Start Date"
              type="date"
              value={revenueStartDate}
              onChange={(e) => setRevenueStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End Date"
              type="date"
              value={revenueEndDate}
              onChange={(e) => setRevenueEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <Box display="flex" gap={3} flexWrap="wrap">
            <Paper
              elevation={1}
              sx={{
                padding: 1,
                minWidth: 250,
                flex: 1,
                backgroundColor: "#f5f7fa",
                borderLeft: "5px solid #2196f3",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" fontWeight="400" gutterBottom>
                Total Commission (New & Renewals)
              </Typography>
              <Typography variant="h6" fontWeight="bold" color="#1565c0">
                {totalCommission.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Paper>
            <Paper
              elevation={1}
              sx={{
                padding: 1,
                minWidth: 250,
                flex: 1,
                backgroundColor: "#f5f7fa",
                borderLeft: "5px solid #4caf50",
              }}
            >
              <Typography fontWeight="400" variant="subtitle2" color="text.secondary" gutterBottom>
                Premiums from
              </Typography>
              <Typography
                sx={{ fontWeight: "500" }}
                fontWeight="400"
                variant="subtitle2"
                color="text.primary"
                gutterBottom
              >
                {`${formatDate(revenueStartDate)} to ${formatDate(revenueEndDate)}`}
              </Typography>
              <Typography variant="h6" fontWeight="bold" color="#2e7d32">
                ₹{" "}
                {monthlyPremiumTotal.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Paper>

            <Paper
              elevation={1}
              sx={{
                padding: 1,
                minWidth: 250,
                flex: 1,
                backgroundColor: "#f5f7fa",
                borderLeft: "5px solid #2196f3",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" fontWeight="400" gutterBottom>
                Payouts from
              </Typography>
              <Typography
                sx={{ fontWeight: "500" }}
                variant="subtitle2"
                color="text.primary"
                fontWeight="400"
                gutterBottom
              >
                {`${formatDate(revenueStartDate)} to ${formatDate(revenueEndDate)}`}
              </Typography>
              <Typography variant="h6" fontWeight="bold" color="#1565c0">
                ₹{" "}
                {monthlyPayoutTotal.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Paper>
          </Box>
        </Box>
        <StyledAgGridContainer
          component={Paper}
          className="ag-theme-alpine"
          sx={{
            flexGrow: 1,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          <AgGridReact
            rowData={revenue}
            columnDefs={columnAgDefs}
            pagination={true}
            defaultColDef={{ floatingFilter: true }}
            paginationPageSize={11}
            pinnedBottomRowData={footerData}
          />
        </StyledAgGridContainer>
      </>
    );
  };

  return (
    <>
      <span style={{ display: "block", paddingTop: "0.7em" }}></span>
      <ResponsiveTabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleChange}
        labelColor="secondary"
        bgColor="#e0f7fa"
        width="900px"
      />
      <StyledTableContainer>
        {activeTab === 0 && (
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{
              flexGrow: 1,
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columns}
              pagination
              defaultColDef={{
                floatingFilter: true,
              }}
              paginationPageSize={11}
            />
          </StyledAgGridContainer>
        )}
        {activeTab === 1 && handleTabChange()}
        {activeTab === 2 && handleTabChange()}
        {activeTab === 3 && handleTabChange()}
        {activeTab === 4 && handleRevenueTabChange()}
      </StyledTableContainer>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <Dialog
        open={loading}
        onClose={null}
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
            boxShadow: "none",
          }}
        >
          <CircularProgress color="primary" />
          <Typography variant="h6" sx={{ marginTop: 2, color: "white" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default InsuranceReportsheet;
